/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Col, Row, Typography } from 'antd';
import { useState } from 'react';
import { Button } from '@/components/button';
import { PlusOutlined } from '@ant-design/icons';
import { PageURLs } from '@/utils/navigate';
import { useQuery } from '@/hooks/query.hook';
import { PermissionMode } from '@/enums/mode.enum';
import NutritionStandardsManagementTable from '@/components/tables/nutrition-standards-management/nutrition-standards-management.table';
// import NutritionStandardImport from '@/components/tables/nutrition-standards-management/nutrition-standards-import.table';

export default function NutritionStandardsManagement() {
  const [activeTab, setActiveTab] = useState('TABLE');
  const [isAddNew, setIsAddNew] = useState(false);
  const { push } = useQuery();

  const onAdd = () => {
    setIsAddNew(true)
  };

  const onAddByGroup = () => {
    setActiveTab('CREATE_BY_LIST');
    push(
      `${PageURLs.ofNutritionStandardsManagement()}?mode=${PermissionMode.CREATE_BY_LIST}`
    );
  };

  return (
    <div css={rootStyles}>
      {!['IMPORT', 'IMPORT_BY_LIST'].includes(activeTab) && (
        <>
          {activeTab === 'TABLE' && (
            <Row css={boxStyles} justify='space-between' align='middle'>
              <Col>
                <Typography.Title css={titleStyles} level={5}>
                  Quản lý tiêu chuẩn dinh dưỡng
                </Typography.Title>
              </Col>

              <Col>
                <Row justify='space-between' css={{ gap: '10px' }}>
                  <Button
                    icon={<PlusOutlined />}
                    iconPosition='start'
                    onClick={onAdd}
                    css={selfInputButtonStyles}
                  >
                    Tự nhập từng tiêu chuẩn dinh dưỡng
                  </Button>
                  <Button css={listInputButtonStyles} onClick={onAddByGroup}>
                    Nhập tiêu chuẩn dinh dưỡng theo danh sách
                  </Button>
                </Row>
              </Col>
            </Row>
          )}
        </>
      )}

      <div css={contentStyles}>
        <NutritionStandardsManagementTable isAddNew={isAddNew} setIsAddNew={() => setIsAddNew(false)}/>
        {/* {activeTab === 'CREATE_BY_LIST' && <NutritionStandardImport />} */}
      </div>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
  font-weight: bold !important;
`;

const selfInputButtonStyles = css`
  color: var(--blue-light-color);
  border-color: var(--blue-light-color);

  &:hover {
    background-color: var(--white-color) !important;
    color: var(--blue-light-color) !important;
    border-color: var(--blue-light-color) !important;
  }
`;

const listInputButtonStyles = css`
  background-color: var(--success-color);
  color: var(--white-color);
  border-color: var(--success-color);

  &:hover {
    background-color: var(--success-color) !important;
    border-color: var(--success-color) !important;
  }
`;
